export enum LocalStorageKeys {
  SessionEmailChanged = "session:emailchanged",
  VipPageShown = "VipPageShown",
  AccountMenuMovedCoachMarkSeen = "AccountMenuMovedCoachMarkSeen",
  /**
   * The person Intercom was last identified as. `IntercomProviderInternal`
   * clears it itself once the session is gone, after it has shut Intercom down
   * on their behalf, so it is not on the logout list below.
   */
  IntercomIdentity = "intercom:identity",
  /**
   * The Chrome extension version last seen in its install cookie, kept so the
   * install banner stays hidden after a browser restart drops that session
   * cookie (`useHasExtension`). It belongs to the browser, not the account,
   * so a logout keeps it.
   */
  ExtensionSeenVersion = "extension:seenVersion",
}

export const LocalStorageKeysThatShouldNotBePersist = [
  LocalStorageKeys.SessionEmailChanged,
];
